export default __webpack_public_path__ + "static/media/player.991e6999.png";